// compability
import 'core-js/stable';
import './src/scripts/helpers/polyfills';

// libraries
import 'bulma-switch';
import 'lazysizes';
import jQuery from 'jquery';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger.js';
import Alpine from 'alpinejs'
window.Alpine = Alpine
window.jQuery = jQuery;
window.$ = jQuery;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);

import './src/scripts/default-vue';
import './style.scss';

import '@fortawesome/fontawesome-free/svgs/solid/map-marked-alt.svg'
import '@fortawesome/fontawesome-free/svgs/solid/clock.svg'
import '@fortawesome/fontawesome-free/svgs/solid/calendar-alt.svg'
import '@fortawesome/fontawesome-free/svgs/solid/child.svg'
import '@fortawesome/fontawesome-free/css/all.css'

import HashScrolling from "./src/scripts/hash-scrolling";
import "./src/scripts/scroll-lock";
import CookieConsentManager from "./src/scripts/helpers/cookie-consent-manager";
window.CookieConsentManager = CookieConsentManager;

import {CartOrderModal} from './Fusion/Integration/Molecule/CartOrderModal/CartOrderModal';

import FloatingCart from './Fusion/Presentation/Molecule/FloatingCart/FloatingCart';
import Video from './Fusion/Presentation/Molecule/Video/Video';
import AreaCategoryFilterBlock from "./Fusion/Presentation/Molecule/AreaCategoryFilterBlock/AreaCategoryFilterBlock";
import AreaSearchBlock from "./Fusion/Presentation/Molecule/AreaSearchBlock/AreaSearchBlock";
import ImageGallery from './Fusion/Presentation/Molecule/ImageGallery/ImageGallery';
import Lightbox from './Fusion/Presentation/Molecule/Lightbox/Lightbox';
import Slider from './Fusion/Presentation/Atom/Slider/Slider';
import VimeoPlayer from './Fusion/Presentation/Molecule/VimeoPlayer/VimeoPlayer';
import YoutubePlayer from './Fusion/Presentation/Molecule/YoutubePlayer/YoutubePlayer';
import CardGrid from "./Fusion/Presentation/Molecule/CardGrid/CardGrid";

import Header from './Fusion/Presentation/Organism/Header/Header';
import HeaderWithHorizontalMenu from "./Fusion/Presentation/Organism/HeaderWithHorizontalMenu/HeaderWithHorizontalMenu";
import HeroSlider from './Fusion/Presentation/Organism/Hero/Hero.Slider';
import Footer from './Fusion/Presentation/Organism/Footer/Footer';
import VertiGisMap from './Fusion/Presentation/Organism/VertiGisMap/VertiGisMap';
import FeedbackSection from "./Fusion/Presentation/Organism/FeedbackSection/FeedbackSection";
import SearchBox from "./Fusion/Presentation/Atom/SearchBox/SearchBox";
import SearchField from "./Fusion/Presentation/Atom/SearchField/SearchField";
import SelectBox from "./Fusion/Presentation/Atom/SelectBox/SelectBox";
import EventsSearchForm from "./Fusion/Presentation/Molecule/EventsSearchForm/EventsSearchForm";
import Datepicker from "./Fusion/Presentation/Atom/Datepicker/Datepicker";
import Scheduler from "./Fusion/Presentation/Molecule/Scheduler/Scheduler";
import Multiselect from "./Fusion/Presentation/Atom/Multiselect/Multiselect";
import CalendarDropdown from "./Fusion/Presentation/Molecule/CalendarDropdown/CalendarDropdown";
import Tabs from "./Fusion/Presentation/Molecule/Tabs/Tabs";
import Accordion from "./Fusion/Presentation/Molecule/Accordion/Accordion";
import PodcastPlayer from "./Fusion/Presentation/Molecule/PodcastPlayer/PodcastPlayer";

import EventPage from "../../../CodeQ.FeratelEvents/NodeTypes/Document/EventPage/EventPage.js";
import '../../../CodeQ.Docuware/Resources/Private/Fusion/Presentation/Organism/DocuwareFileViewer/DocuwareFileViewer';

// Alpine data components
import "./Fusion/Presentation/Molecule/Seatplan/Seatplan";
import "./Fusion/Presentation/Molecule/CollapsableContent/CollapsableContent";
import "./Fusion/Presentation/Organism/ProjectList/ProjectList";

// init application
class App {
	constructor() {
        CartOrderModal.init();

        HashScrolling.init();
        FloatingCart.init();
		Video.init();

		AreaSearchBlock.init();
        AreaCategoryFilterBlock.init();
		Lightbox.init();
		Slider.init();
		ImageGallery.init();
		Video.init();
        VimeoPlayer.init();
		YoutubePlayer.init();
        CardGrid.init();

		Header.init();
        HeaderWithHorizontalMenu.init();
		HeroSlider.init();
		Footer.init();
        VertiGisMap.init();
		FeedbackSection.init();
		SearchBox.init();
        SearchField.init();
		SelectBox.init();
		Datepicker.init();
        Scheduler.init();
		EventsSearchForm.init();
		Multiselect.init();
		CalendarDropdown.init();
		Tabs.init();
		Accordion.init();
        PodcastPlayer.init();

        EventPage.init();

        Alpine.start();
	}

	get() {
		return this;
	}
}

window.app = new App();

// This helper adds a global method to copy text to the users clipboard
window.copyToClipboard = (text) => {
    navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
        if (result.state === "granted" || result.state === "prompt") {
            navigator.clipboard.writeText(text).then(() => {
                alert('Inhalt kopiert!');
            }, () => {
                alert('Der Inhalt konnte nicht kopiert werden!');
            });
        } else {
            alert('Ihr Browser erlaubt kein Kopieren von Inhalten!');
        }
    });
}
